import { Component, Input, OnInit } from '@angular/core';
import { baseUrls } from 'src/app/appConstant';

@Component({
  selector: 'app-card-schedule',
  templateUrl: './card-schedule.component.html',
  styleUrls: ['./card-schedule.component.scss']
})
export class CardScheduleComponent implements OnInit {
  imageUrl = baseUrls.images;
  siteUrl = baseUrls.hostedUrl;
  constructor() { }

  ngOnInit(): void {
    // console.log('CardScheduleComponent_ngOnInit', this.scheduleInfo);
  }

  @Input('scheduleInfo')scheduleInfo;

  // goToClassGroupModeRoute(){
  //     window.location.href = 'https://mytripwell.clientwork.xyz/livewell/groupmode/gyg';
  // }
  goToClassGroupModeRoute(groupModeInfo){
    if(groupModeInfo?._id){
        window.location.href = this.siteUrl+'sesapp/groupmode/'+groupModeInfo?._id;
    }
  }
  goToClassOneOnOneModeRoute(oneToOneInfo){
    if(oneToOneInfo?._id){
        window.location.href = this.siteUrl+'sesapp/onetoonemode/'+oneToOneInfo?._id;
    }
}
ConvertString(value){
  return parseFloat(value)
  }

  goToClassOneOnOneOrGroupModeRoute(oneToOneOrGroupModeInfo){
    if(oneToOneOrGroupModeInfo?._id){
       if(oneToOneOrGroupModeInfo?.platformProduct === 'ONEONONE'){
        //  window.location.href = this.siteUrl+'sesapp/onetoonemode/'+oneToOneOrGroupModeInfo?._id;
         window.open(
          this.siteUrl+'sesapp/onetoonemode/'+oneToOneOrGroupModeInfo?._id,
          '_blank'
        );
       }
       if(oneToOneOrGroupModeInfo?.platformProduct === 'VOD'){
        // window.location.href = this.siteUrl+'sesapp/groupmode/'+oneToOneOrGroupModeInfo?._id;
        window.open(
          this.siteUrl+'sesapp/groupmode/'+oneToOneOrGroupModeInfo?._id,
          '_blank'
        );
       }
    }
  }
}
